import React, { useState,useEffect } from 'react';
import { Formik } from "formik";
import validationSchema from './schemaUsuario';

export default function Adduser(props) {
    const { AddUser, Ciudades, SingleU, TipoUserLog, Porcentaje } = props;
    const isEmty = Object.keys(SingleU).length === 0;
    const [percent,Setpercent]=useState(isEmty?[]:Porcentaje.filter((itm)=>itm.tipo_usuario_id==SingleU.tipo_usuario));

    const OnchangePercent=(tipo)=>{
        let newA=Porcentaje.filter((itm)=>itm.tipo_usuario_id==parseInt(tipo));
        Setpercent(newA);
    }

    useEffect(()=>{
        let newA=Porcentaje.filter((itm)=>itm.tipo_usuario_id==SingleU.tipo_usuario);
        Setpercent(newA);
    },[isEmty])

    return (
        <Formik
            initialValues={isEmty ? {
                id: 0,
                nombre: '',
                direccion: '',
                ine: '',
                tel: '',
                email: '',
                tipo_usuario: TipoUserLog == 1 ? '' : 3,
                id_ciudad: '',
                margen: '0',
                importe_cola: '0',
                importe_premio: '0',
                dias_credito: '0',
                usuario_creador: '',
                importe_cola2: '0',
                importe_premio2: '0',
                contrasena: '',
                tipo_user_log: TipoUserLog
            } : SingleU}
            validationSchema={validationSchema}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                //alert("pass");
                AddUser(values, actions);
                //console.log('actions', actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <div className="modal" id="addSorteo" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Añadir nuevo usuario</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit} autoComplete="off" >
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className={errors.nombre ? "form-group" : "form-group"}>
                                                <label htmlFor="exampleInputEmail1">Nombre:</label>
                                                <input type="text" onChange={handleChange} value={values.nombre || ""} className={errors.nombre ? "form-control has-error" : "form-control"} name="nombre" id="nombre" autoComplete="none" />
                                                <span className="help-block">{errors.nombre}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Dirección:</label>
                                                <input type="text" className={errors.direccion ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.direccion || ""} name="direccion" id="direccion" autoComplete="none" />
                                                <span className="help-block">{errors.direccion}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">INE:</label>
                                                <input type="text" className={errors.ine ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.ine || ""} name="ine" id="ine" autoComplete="none" />
                                                <span className="help-block">{errors.ine}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Telefono:</label>
                                                <input type="text" className={errors.tel ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.tel || ""} name="tel" id="tel" autoComplete="none" />
                                                <span className="help-block">{errors.tel}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Correo:</label>
                                                <input type="text" className={errors.email ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.email || ""} name="email" id="email" autoComplete="none" />
                                                <span className="help-block">{errors.email}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {TipoUserLog == 1 ? <div className={TipoUserLog == 2 ? `col-sm-6 col-md-6 col-lg-6` : `col-sm-4 col-md-4 col-lg-4`}>
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Tipo:</label>
                                                <select name="tipo_usuario" id="tipo_usuario" className={errors.tipo_usuario ? "form-select has-error" : "form-select"} onChange={(e)=>{setFieldValue('tipo_usuario',e.target.value),OnchangePercent(e.target.value)}} value={values.tipo_usuario || ""} autoComplete="none">
                                                    <option value="">Seleccione una opción</option>
                                                    {/* <option value="1">Administrador</option> */}
                                                    {TipoUserLog == 1 ?
                                                        <>
                                                            <option value="2">Coperativa</option>
                                                            <option value="3">Corredor</option>
                                                        </> :
                                                        <>
                                                            <option value="3">Corredor</option>
                                                        </>}
                                                </select>
                                                <span className="help-block">{errors.tipo_usuario}</span>
                                            </div>
                                        </div> :
                                            ''}
                                       {/*  {TipoUserLog != 1 && (
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Margen:</label>
                                                    <select name="margen" id="margen" className={errors.margen ? "form-select has-error" : "form-select"} onChange={handleChange} value={values.margen || ""} autoComplete="none">
                                                        <option value="0">Seleccione una opción</option>
                                                        {Porcentaje && Porcentaje.map((item, key) => (
                                                            <option value={item.porcentaje} key={key}>{item.porcentaje}</option>
                                                        ))}
                                                    </select>
                                                    <span className="help-block">{errors.margen}</span>
                                                </div>
                                            </div>
                                        )} */}
                                        <div className={TipoUserLog == 2 ? `col-sm-4 col-md-4 col-lg-4` : `col-sm-4 col-md-4 col-lg-4`}>
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Ciudad:</label>
                                                <select name="id_ciudad" id="id_ciudad" className={errors.id_ciudad ? "form-select has-error" : "form-select"} onChange={handleChange} value={values.id_ciudad || ""} autoComplete="none">
                                                    <option value="">Seleccione una opción</option>
                                                    {Ciudades && Ciudades.map((item, key) => (
                                                        <option value={item.id} key={key}>{item.ciudad}</option>
                                                    ))}
                                                </select>
                                                <span className="help-block">{errors.id_ciudad}</span>
                                            </div>
                                        </div>
                                        {TipoUserLog != 1 && (
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Contraseña:</label>
                                                    <input type="text" className={errors.contrasena ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.contrasena || ''} name="contrasena" id="contrasena" autoComplete="none" />
                                                    <span className="help-block">{errors.contrasena}</span>
                                                </div>
                                            </div>
                                        )}
                                        {TipoUserLog == 1 && (
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Margen:</label>
                                                    <select name="margen" id="margen" className={errors.margen ? "form-select has-error" : "form-select"} onChange={handleChange} value={values.margen || ""} autoComplete="none">
                                                        <option value="0">Seleccione una opción</option>
                                                        {percent && percent.map((item, key) => (
                                                            <option value={item.porcentaje} key={key}>{item.porcentaje}</option>
                                                        ))}
                                                        {/* {Porcentaje && Porcentaje.map((item, key) => (
                                                            <option value={item.porcentaje} key={key}>{item.porcentaje}</option>
                                                        ))} */}
                                                    </select>
                                                    <span className="help-block">{errors.margen}</span>
                                                </div>
                                            </div>
                                            /*  <div className="col-sm-4 col-md-4 col-lg-4">
                                                 <div className="form-group">
                                                     <label htmlFor="exampleInputEmail1">Margen:</label>
                                                     <input type="number" className={errors.margen ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.margen || ''} name="margen" id="margen" autoComplete="none" />
                                                     <span className="help-block">{errors.margen}</span>
                                                 </div>
                                             </div> */
                                        )}
                                    </div>
                                    {TipoUserLog == 1 && (
                                        <div className='row'>
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Importe cola:</label>
                                                    <input type="number" className={errors.importe_cola ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.importe_cola || ''} name="importe_cola" id="importe_cola" autoComplete="none" />
                                                    <span className="help-block">{errors.importe_cola}</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Importe premio:</label>
                                                    <input type="number" className={errors.importe_premio ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.importe_premio || ''} name="importe_premio" id="importe_premio" autoComplete="none" />
                                                    <span className="help-block">{errors.importe_premio}</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Dias credito:</label>
                                                    <input type="number" className={errors.dias_credito ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.dias_credito || ''} name="dias_credito" id="dias_credito" autoComplete="none" />
                                                    <span className="help-block">{errors.dias_credito}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {TipoUserLog == 1 && (
                                        <div className='row'>
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Importe cola 2:</label>
                                                    <input type="number" className={errors.importe_cola2 ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.importe_cola2 || ''} name="importe_cola2" id="importe_cola2" autoComplete="none" />
                                                    <span className="help-block">{errors.importe_cola2}</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Importe premio 2:</label>
                                                    <input type="number" className={errors.importe_premio2 ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.importe_premio2 || ''} name="importe_premio2" id="importe_premio2" autoComplete="none" />
                                                    <span className="help-block">{errors.importe_premio2}</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 col-lg-4">
                                                <div className="form-group">
                                                    <label htmlFor="exampleInputEmail1">Contraseña:</label>
                                                    <input type="text" className={errors.contrasena ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.contrasena || ''} name="contrasena" id="contrasena" autoComplete="none" />
                                                    <span className="help-block">{errors.contrasena}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => () => resetForm()} >Cancelar</button>
                                    <button type='submit' className="btn btn-success">Guardar</button>
                                    {/*  <a onClick={()=>console.log("values",values)}>test etstate </a> */}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
        </Formik>
    )
}
